export default function CopyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.00037 5.10656L5 13.125C5 14.7819 6.28942 16.1375 7.91953 16.2434L8.125 16.25L13.643 16.2509C13.3854 16.9787 12.6911 17.5 11.875 17.5H7.5C5.42893 17.5 3.75 15.8211 3.75 13.75V6.875C3.75 6.05848 4.27193 5.36386 5.00037 5.10656ZM14.375 2.5C15.4105 2.5 16.25 3.33947 16.25 4.375V13.125C16.25 14.1605 15.4105 15 14.375 15H8.125C7.08947 15 6.25 14.1605 6.25 13.125V4.375C6.25 3.33947 7.08947 2.5 8.125 2.5H14.375ZM14.375 3.75H8.125C7.77982 3.75 7.5 4.02982 7.5 4.375V13.125C7.5 13.4702 7.77982 13.75 8.125 13.75H14.375C14.7202 13.75 15 13.4702 15 13.125V4.375C15 4.02982 14.7202 3.75 14.375 3.75Z"
        fill="#155DFC"
      />
    </svg>
  );
}
